/*
* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/
import {
  CodeSnippet,
  EmptyState,
  ItemCardGrid,
  WarningPanel,
} from '@backstage/core-components';
import { useEntityList } from '@backstage/plugin-catalog-react';
import { Box, Card, CircularProgress } from '@material-ui/core';

import { CatalogCard } from './CatalogTile';

const CatalogEmptyState = () => (
  <Card
    style={{
      padding: '12px',
    }}
  >
    <EmptyState
      missing="content"
      title="No components to show"
      description="Register your component, check out our Component Registration guide"
      // action={
      //   <LinkButton
      //     to="/docs/default/component/bh-cordant-developer-portal/service_registration"
      //     variant="contained"
      //     color="primary"
      //     target="_blank"
      //   >
      //     Component Registration
      //   </LinkButton>
      // }
    />
  </Card>
);

/** @public */
export const CatalogTileGrid = () => {
  const { error, entities, loading } = useEntityList();

  if (error) {
    return (
      <div>
        <WarningPanel
          severity="error"
          title="Could not fetch catalog entities."
        >
          <CodeSnippet language="text" text={error.toString()} />
        </WarningPanel>
      </div>
    );
  }

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          minHeight: '15rem',
        }}
      >
        <CircularProgress size="5rem" />
      </Box>
    );
  }

  return !entities || entities.length <= 0 ? (
    <CatalogEmptyState />
  ) : (
    <ItemCardGrid>
      {entities.map((entity, _index) => {
        return <CatalogCard entity={entity} key={entity.metadata.name} />;
      })}
    </ItemCardGrid>
  );
};
